import list from './list'
import icon from '@mui/icons-material/QueryStats';

const adminConfig = { list, icon };

export default adminConfig;
